<template>
  <div class="user-video" dir="ltr">
    <div class="header__user-video">
        <p>Your video - You can move me</p>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.6663 4.27333L11.7263 3.33333L7.99967 7.06L4.27301 3.33333L3.33301 4.27333L7.05967 8L3.33301 11.7267L4.27301 12.6667L7.99967 8.93999L11.7263 12.6667L12.6663 11.7267L8.93967 8L12.6663 4.27333Z" fill="black"/>
        </svg>
    </div>
    <div class="body__user-video">
    
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped> 
    .user-video{
        position: relative;
        width: 265px;
        height: 174px;
        border-radius: 16px;
        background-color: #8D99A0;
        .header__user-video{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 36px;
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 5px 12px;
            background-color: #fff;
            p{
                font-family: 'Nunito', sans-serif;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 19px;
                color: #000000;
                margin: 0;
            }
            svg{
                cursor: pointer;;
            }
        }
        .header__user-body{

        }
    }

    @media (max-width: 991px){
        .user-video{
          .header__user-video{
              background-color: transparent;
              justify-content: flex-end;
              p{
                  display: none !important;
                  
              }
          }
        }
    }
</style>